export default __webpack_public_path__ + "static/media/OfflineBackground.0695d7ca.svg";